var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseKeyboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23L16 19H8M4 3C2.9 3 2 3.9 2 5V15C2 16.1 2.9 17 4 17H20C21.1 17 22 16.1 22 15V5C22 3.9 21.1 3 20 3H4ZM4 5H20V15H4V5ZM5 6V8H7V6H5ZM8 6V8H10V6H8ZM11 6V8H13V6H11ZM14 6V8H16V6H14ZM17 6V8H19V6H17ZM5 9V11H7V9H5ZM8 9V11H10V9H8ZM11 9V11H13V9H11ZM14 9V11H16V9H14ZM17 9V11H19V9H17ZM8 12V14H16V12H8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseKeyboard);
export default __webpack_public_path__ + "static/media/close-keyboard.91099d7cf228c68c8d32564c69768bcc.svg";
export { ForwardRef as ReactComponent };